/* eslint-disable react-hooks/rules-of-hooks */
import { useIsomorphicLayoutEffect } from '@socar-inc/hooks'
import { isAndroidDevice } from '@socar-inc/utils'
import Head from 'next/head'
import { Fragment, useState } from 'react'

export const withHeadTitle = <P extends object>(
  Component: React.ComponentType<P>,
  title: string = ''
) => {
  return (props: P) => {
    const [defaultTitle, setDefaultTitle] = useState(() => title)

    useIsomorphicLayoutEffect(() => {
      setDefaultTitle((prev) =>
        /**
         * @link https://socar.slack.com/archives/C01FV172JRY/p1687225489348449?thread_ts=1687222505.286319&cid=C01FV172JRY
         * @description Android 기기에서 네이티브 액션바의 제목을 빈 타이틀로 하기 위해선 'SOCAR' 문자열을 넣어야 한다.
         */
        isAndroidDevice(navigator.userAgent) ? 'SOCAR' : prev
      )
    }, [])

    return (
      <Fragment>
        <Head>
          <title>{title || defaultTitle}</title>
        </Head>
        <Component {...props} />
      </Fragment>
    )
  }
}
